import { Component, OnInit } from '@angular/core';
import { ContextService } from 'app/services/context.service';

@Component({
  selector: 'app-submitted',
  templateUrl: './submitted.component.html',
  styleUrls: ['./submitted.component.css']
})
export class SubmittedComponent implements OnInit {
  focus: any;
  focus1: any;
  isEosRequired = false;
  qsppAssessmentTypeLabel = '';

  constructor(private context: ContextService) { }

  private getQsppAssessmentTypeLabel(assessmentTypeId: string): string {
    switch (assessmentTypeId) {
      case '806390002':
        return 'Expansion of Service Assessment';
      case '806390003':
        return 'Transition Assessment';
      case '806390005':
        return 'Mid Cycle Review Assessment';
      default:
        return '';
    }
  }

  ngOnInit(): void {
    this.isEosRequired = sessionStorage.getItem('PSD15_EOS_REQUIRED') === 'true';

    const localAssessmentTypeId = localStorage.getItem('assessmentType') || '';
    this.qsppAssessmentTypeLabel = this.getQsppAssessmentTypeLabel(localAssessmentTypeId);

    this.context.remoteAssessment.subscribe(ra => {
      const assessmentTypeId = String(ra?.assessment?.assessmentType?.id || '');
      const label = this.getQsppAssessmentTypeLabel(assessmentTypeId);
      if (label) {
        this.qsppAssessmentTypeLabel = label;
      }
    });
  }

}
